import { STATUS_OBJECT } from 'constants/variables'
import { ProfessionalContractTypeFilterKeyString } from '../types'

export function getProfessionalContractTypeFilterFeedbacks(value: string) {
  const status = STATUS_OBJECT[value] ? STATUS_OBJECT[value].text : ''

  const professionalContractTypeFilterFeedbacks: ProfessionalContractTypeFilterKeyString = {
    search: `Geral: ${value}`,
    id: `ID: ${value}`,
    name: `Nome: ${value}`,
    description: `Descrição: ${value}`,
    status: `Status: ${status}`,
  }

  return professionalContractTypeFilterFeedbacks
}
